"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var BannerNoticeStore = /*#__PURE__*/function (_RootStore) {
  function BannerNoticeStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, BannerNoticeStore);
    _this = _callSuper(this, BannerNoticeStore);
    _this.config = {
      model: _models.BannerNotice,
      deserialize: true,
      GET: {
        index: '/banner_notices',
        show: '/banner_notices/:bannerNoticeId'
      },
      POST: {
        create: '/banner_notices'
      },
      PUT: {
        update: '/banner_notices/:bannerNoticeId',
        incrementClickedCount: '/banner_notices/:bannerNoticeId/increment_clicked_count',
        duplicate: '/banner_notices/:bannerNoticeId/duplicate'
      },
      DELETE: {
        destroy: '/banner_notices/:bannerNoticeId'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(BannerNoticeStore, _RootStore);
  return (0, _createClass2["default"])(BannerNoticeStore, [{
    key: "incrementClickedCount",
    value: function incrementClickedCount(params, callback) {
      this.api(params, callback, 'PUT', 'incrementClickedCount');
    }
  }, {
    key: "duplicate",
    value: function duplicate(params, callback) {
      this.api(params, callback, 'PUT', 'duplicate');
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new BannerNoticeStore();